import React, { Component } from 'react';
import { Route, Router, browserHistory } from 'react-router';
import VendorOnboarding from './VendorOnboard';
import VendorInfo from './VendorPreview';
import HomeScreen from './HomeScreen';
import PendingVendors from './PendingVendors';
import ApprovedVendors from './ApprovedVendors';
import VendorAprrovalPreview from './VendorApproval';
import BankUploadedDetails from './BankUploadedDetails';
import PaymentRequest from './PaymentRequestOnboard';
import PaymentStatus from './PaymentStatus';
import PaymentProcess from './PaymentProcess';
import BufRejectedPayments from './BufRejectedPayments';
import ViewPNGFiles from './ViewPNGFiles';
import ViewPDFFiles from './ViewPDFFiles';
import AddCostCenter from './AddCostCenter';
import Login from './Login';
import Preview from './Preview';
import UserListingPage from './UserListingPage';
import InitializePR from './InitializePR';
import BulkPreview from './BulkPreview';
import Reports from './Reports';
import PaymentsReport from './PaymentsReport';
import AccountingReport from './AccountingReport';
import BillSubmissionReport from './BillSubmissionReport';
import LedgerBasedBillingReport from './LedgerBasedBillingReport';
import CostOwnerCenterReport from './CostOwnerCenterReport';
import ViewCostCenter from './ViewCostCenter';
import { checkLogin } from '../services/hrmsUser/hrmsUser.service';
import PaymentRequestPreview from './PaymentRequestPreview'; // Ensure this path is correct
import PaymentRequestTimeline from './PaymentRequestTimeline';
import TallyExcelUpload from './TallyExcelUpload';
import CityManagement from './CityManagement';
import BusinessUnitManagement from './BusinessUnitManagement';
import RecoverableAmountConfig from './RecoverableAmountConfig';
import BifrostAuthGate from './BifrostAuthGate';
import token from '../config/jwt_token';
import { handleLogout } from '../utils/authHelper';

class App extends Component {

  async componentWillMount() {
    // Only check forced logout if user is authenticated
    if (!token || !token.role) return;

    try {
      const shouldLogout = await checkLogin();
      if (shouldLogout && shouldLogout.status === 200 && shouldLogout.data.flag === true) {
        handleLogout();
        return;
      }
    } catch (err) {
      // checkLogin failure is non-fatal
      console.warn('checkLogin failed:', err);
    }

    const pathname = browserHistory.getCurrentLocation().pathname;
    const reportAccessPaths = ['/payment/reports', '/payment/accountingReport', '/payment/billSubmissionReport', '/payment/provisionReport', '/payment/paymentsReport', '/payment/tally-excel-upload', '/payment/costOwnerCenterReport']
    if (token && token.role === 'Report Viewer' && !reportAccessPaths.includes(pathname)) {
      browserHistory.push('/payment/reports')
      return
    }

    const costReportViewerPaths = ['/home', '/payment/reports', '/payment/costOwnerCenterReport']
    if (token && token.role === 'Cost Report Viewer' && !costReportViewerPaths.includes(pathname)) {
      browserHistory.push('/payment/costOwnerCenterReport')
      return
    }

    if (token && token.role === 'Payment Hold Operator') {
      browserHistory.push('/vendor/payment/approved')
      return
    }
  }

  render() {
    return (
      <BifrostAuthGate>
        <Router history={browserHistory}>
          <div>
            <Route path='/' component={Login} />
            <Route path='/home' component={HomeScreen} />
            <Route path='/vendor/onboard' component={VendorOnboarding} />
            <Route path='/vendor/approved' component={ApprovedVendors} />
            <Route path='/vendor/pending' component={PendingVendors} />
            <Route path='/vendor/:entity/edit' component={VendorOnboarding} />
            <Route path='/vendor/payment/:entity/preview' component={Preview} />
            <Route path='/vendor/payment/:entity' component={PaymentProcess} />
            <Route path='/vendor/approval' component={PendingVendors} />
            <Route path='/vendor/approval-preview' component={VendorAprrovalPreview} />
            <Route path='/vendor/:entity/info' component={VendorInfo} />
            <Route path='/payment/request' component={PaymentRequest} />
            <Route path='/payment/request/edit' component={PaymentRequest} />
            <Route path='/payment/status' component={PaymentStatus} />
            <Route path='/payment/generated_buf' component={BankUploadedDetails} />
            <Route path='/payment/buf-rejected' component={BufRejectedPayments} />
            <Route path='/payment/reports' component={Reports} />
            <Route path='/payment/paymentsReport' component={PaymentsReport} />
            <Route path='/payment/accountingReport' component={AccountingReport} />
            <Route path='/payment/billSubmissionReport' component={BillSubmissionReport} />
            <Route path='/payment/provisionReport' component={LedgerBasedBillingReport} />
            <Route path='/payment/costOwnerCenterReport' component={CostOwnerCenterReport} />
            <Route path='/payment/tally-excel-upload' component={TallyExcelUpload} />
            <Route path='/view/pngFile' component={ViewPNGFiles} />
            <Route path='/view/pdfFile' component={ViewPDFFiles} />
            <Route path='/cost-center/add' component={AddCostCenter} />
            <Route path='/cost-center/view' component={ViewCostCenter} />
            <Route path="/users" component={UserListingPage} />
            <Route path='/initializePR' component={InitializePR} />
            <Route path='/bulkPreview' component={BulkPreview} />
            <Route path='/payment/payment-request-preview' component={PaymentRequestPreview} />
            <Route path='/payment/payment-request-preview/timeline' component={PaymentRequestTimeline} />
            <Route path='/cities' component={CityManagement} />
            <Route path='/business-units' component={BusinessUnitManagement} />
            <Route path='/recoverable-amount-config' component={RecoverableAmountConfig} />
            <Route path="*" component={PageNotFound} />
          </div>
        </Router>
      </BifrostAuthGate>
    )
  }
}
const PageNotFound = () => <h1>404 Error. Page Not Found!</h1>

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js